<template>
  <div class="detail">
    <ODFLayout
      class="detail__left"
      :title="$store.state.config.common.brand"
      :link="'/'"
      :theme="parent.theme"
      :blason="parent.intro.blason"
      :pattern="parent.intro.pattern"
    >
      <div
        slot="header"
        class="detail__nav"
      >
        <ButtonDefault
          class="button-back"
          :theme="parent.theme"
          arrow="left"
          :to="{name: parent.globalId}"
          negative
          reverse
        >
          {{ content.back }}
        </ButtonDefault>
      </div>

      <div class="detail__content">
        <article class="video">
          <header>
            <div class="texts">
              <h2>{{ content.video.title }}</h2>
              <p class="description">
                {{ content.video.description }}
              </p>
            </div>
            <div class="links">
              <HistoryNavButton
                v-for="item in navItems"
                :key="item.year"
                :year="item.year"
                :name="item.name"
                :theme="parent.theme"
                :path="item.path"
                :picto-top="(item.config.intro.history || [])[0]"
                :picto-bottom="(item.config.intro.history || [])[1]"
              />
            </div>
          </header>
          <div class="player-video">
            <youtube
              ref="youtube"
              class="player"
              :player-vars="playerVars"
              :video-id="youtubeId"
            />
          </div>
        </article>

        <article class="museum">
          <header>
            <h2>{{ content.museum.title }}</h2>
            <p class="description">
              {{ content.museum.description }}
            </p>
            <ButtonDefault
              :label="$store.state.config.common.discoverMuseumButton"
              :theme="parent.theme"
              arrow="top-right"
              :to="urlMuseum"
              negative
            />
          </header>
          <div
            class="image"
            :class="content.museum.image"
          />
        </article>
        <div
          slot="footer"
          class="footer"
        >
          <ButtonDefault
            class="button-back"
            :theme="parent.theme"
            arrow="left"
            :to="{name: parent.globalId}"
            negative
            reverse
          >
            {{ content.back }}
          </ButtonDefault>
        </div>
      </div>
    </odflayout>
  </div>
</template>

<script>
import ODFLayout from '@/components/ODFLayout.vue';
import ButtonDefault from '@/components/buttons/ButtonDefault.vue';
import HistoryNavButton from '@/components/navigation/HistoryNavButton.vue';

export default {
  components: {
    ODFLayout,
    ButtonDefault,
    HistoryNavButton,
  },
  data() {
    return {
      playerVars: {
        autoplay: 0,
        controls: 1,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
      },
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },

    content() {
      return this.$store.getters.getDataById(this.routeName);
    },

    parent() {
      const parent = this.$store.getters.getParentData(this.routeName);
      if (parent.is && parent.is === 'Products') {
        return parent;
      }
      return null;
    },

    urlMuseum() {
      return window.___museum;
    },

    youtubeId() {
      if (!this.parent) return null;
      return window[`___${this.parent.id}___youtube`];
    },

    navItems() {
      const productRoutes = this.$store.getters.getCollectionRoutes();
      return productRoutes.map((route) => {
        const history = route.routes ? route.routes.find(r => r.id === 'history') : null;
        const path = history ? { name: history.globalId } : null;
        const name = history ? route.name : '';

        return {
          name, year: route.year, path, theme: route.theme, config: this.$store.getters.getRouteConfig(route),
        };
      });

      // return productRoutes.map(r => ({
      //   name: r.name,
      //   year: r.year,
      //   path: r.path,
      //   theme: r.theme,
      //   config: this.$store.getters.getRouteConfig(r),
      // }));
    },
  },
};
</script>

<style lang="stylus" scoped>
.detail {
  &--theme-green { background-color: $cl-green; }
  &--theme-purple { background-color: $cl-purple; }
  &--theme-orange { background-color: $cl-orange; }

  >>> .odf-layout__head {
    +mobile() {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  >>> .odf-layout__title {
    +mobile() {
      margin: 30px auto;
    }
  }
}


.button-back {
  margin-top: 20px;
  +mobile() {
    margin-top: 0px;
  }
  >>> .button-default__label {
    background-color: transparent;
    color: $cl-white;
    text-decoration: underline;
    +mobile() {
      flex-grow: 0;
    }
  }
}


.detail__left {
  flex-grow: 1;
  overflow: hidden;
  padding-bottom: 0;
  +desktop() {
    padding-bottom: 30px;
  }
}

.detail >>> .odf-layout__custom-content {
  +desktop() {
    height: 100%;
  }
}

.detail >>> .odf-layout__background {
  height: 100%;
}

.detail__content {
  margin: 0px auto;
  +mobile() {
    width: calc(100% - 40px);
  }
  +desktop() {
    max-width: 1100px;
    padding-top: 210px;
  }
  +between('l', 'xl') {
    max-width: 860px;
  }
}

h2 {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 800;
  font-size: 28px;
  line-height: 34px;
  color: $cl-white;
}

p.description {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 140%;
  padding: 0;
  margin: 0;
  color: #FFFFFF;
}

article {
  display: flex;
  flex-direction: column;
  gap: 30px;
  +desktop() {
    gap: 98px;
  }
  header {
    display: flex;
    flex-direction: column;
  }
  &.video {

    gap: 60px;
    header {
      display: flex;
      +mobile() {
        flex-direction: column-reverse;
        gap: 30px;
      }
      +desktop() {
        flex-direction: row;
        justify-content: space-between;
        align-items: top;
      }
      .texts {
        display: flex;
        flex-direction: column;

        +desktop() {
          width: 500px;
        }
        +above('xxl') {
          width: 740px;
        }
        gap: 20px;
      }
    }
  }
  &.museum {
    flex-direction: column-reverse;
    +desktop() {
      flex-direction: row-reverse;
    }
    header {
      justify-content: center;
      gap: 20px;
      +desktop() {
        width: 500px
      }
    }

    .image {
      margin: 0px auto;
      +between('l', 'xl') {
        width: 250px !important;
        height: 250px;
        background-size: 250px 250px;
      }
    }

  }
}
article + article {
  margin: 50px 0;
  +desktop() {
    margin: 100px 0;
  }
}

.player-video {
  width: 100%;
  aspect-ratio: 16 / 9;
  >>> iframe {
    width: 100%;
    height: 100%;
  }
}

.footer {
  margin: 50px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.links {
  display: flex;
  gap: 18px;
  justify-content: center;

}
</style>

